import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import * as RoutesDefinitions from 'apps/console/src/app/routes-definitions';

@Component({
	selector: 'menu-links',
	templateUrl: './menu-links.component.html',
	imports: [RouterModule, TranslateModule]
})
export class MenuLinksComponent implements OnInit {
	private route = inject(ActivatedRoute);


	subsidaryId: number;

	subsidiariesPath = RoutesDefinitions.getSubsidiariesFullPath();

	ngOnInit() {
		this.subsidaryId = this.route.snapshot.params.id;
	}


	get subsidiaryDetailCompanyPath() {
		return RoutesDefinitions.getSubsidiaryDetailCompanyFullPath(this.subsidaryId);
	}

	get subsidiaryDetailUsersPath() {
		return RoutesDefinitions.getSubsidiaryDetailUsersFullPath(this.subsidaryId);
	}

}
